import React, { useState, useEffect } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { toast, Bounce } from "react-toastify";
// import { DaySelector } from "./day-selector";

export default function JobScheduleAdd({
  setForceUpdate,
  forceUpdate,
  activateJobScheduleAdd,
  setActivateJobScheduleAdd,
}) {
  let navigate = useNavigate();

  const [campusId, setCampusId] = useState("");
  const [collegeId, setCollegeId] = useState("");
  const [campusList, setCampusList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [cleaningType, setCleaningType] = useState("");
  const [assignDate, setAssignDate] = useState("");
  const [eduCompany, setEduCompany] = useState("");
  const [eduCompanyList, setEduCompanyList] = useState([]);
  useEffect(() => {
    if (activateJobScheduleAdd) {
      (async () => {
        try {
          let response = await axios(`${baseUrl}/get_campus/`, {
            method: "GET",
            headers: {
              Authorization: "Token " + localStorage.getItem("token"),
            },
          });
          if (response?.status === 200) {
            setCampusList(
              response?.data?.data?.map((m) => ({
                id: m?.id,
                campus_name: m?.campus_name,
              }))
            );
            setEduCompanyList(response?.data?.data || []);
          } else {
            setCampusList([]);
            setEduCompanyList([]);
          }
        } catch (error) {
          console.error("Error fetching campus data:", error);
          setCampusList([]);
          setEduCompanyList([]);
        }
      })();
    }
  }, [activateJobScheduleAdd]);

  useEffect(() => {
    if (activateJobScheduleAdd) {
      (async () => {
        try {
          let response = await axios(`${baseUrl}/get_college/`, {
            method: "GET",
            headers: {
              Authorization: "Token " + localStorage.getItem("token"),
            },
          });
          if (response?.status === 200) {
            setCollegeList(
              response?.data?.data?.map((m) => ({
                id: m?.id,
                college_name: m?.block_name,
                campus_id: m?.campus,
              }))
            );
          }
        } catch (error) {
          console.error("Error fetching college data:", error);
          setCollegeList([]);
        }
      })();
    }
  }, [activateJobScheduleAdd]);

  // Fetch blocks when campus is selected
  useEffect(() => {
    if (campusId) {
      (async () => {
        try {
          let response = await axios(
            `${baseUrl}/college_based_block_api/?campus=${campusId}`,
            {
              method: "GET",
              headers: {
                Authorization: "Token " + localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            }
          );
          if (response?.status === 200) {
            setBlockList(response?.data?.data || []);
          }
        } catch (error) {
          console.error("Error fetching blocks:", error);
          setBlockList([]);
          // Don't show error toast to avoid breaking the page
        }
      })();
    } else {
      setBlockList([]);
    }
  }, [campusId]);

  let ChangeHandler = (e) => {
    setCampusId(e.target.value);
    setCollegeId(""); // Reset college selection when campus changes
  };

  let CollegeChangeHandler = (e) => {
    setCollegeId(e.target.value);
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item === arr2[index]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Form validation - check if all required fields are filled
    if (
      !eduCompany ||
      !campusId ||
      !collegeId ||
      !cleaningType ||
      !assignDate
    ) {
      let missingFields = [];

      if (!eduCompany) missingFields.push("Company");
      if (!campusId) missingFields.push("College");
      if (!collegeId) missingFields.push("Block");
      if (!cleaningType) missingFields.push("Cleaning Type");
      if (!assignDate) missingFields.push("Assign Date");

      toast.error(
        `Please fill all required fields: ${missingFields.join(", ")}`,
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
      return; // Stop execution if validation fails
    }

    let response;
    try {
      response = await axios(`${baseUrl}/create_scheduler/`, {
        method: "POST",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: {
          assign_date: assignDate,
          college: parseInt(collegeId),
          cleaning_type: cleaningType,
          company: eduCompany,
          campus: parseInt(campusId),
        },
      });
      if (response?.status === 200) {
        let unique = document.getElementById("close5");
        unique.click();
        setActivateJobScheduleAdd(false);
        setForceUpdate(!forceUpdate);
        toast.success("JobSchedule added Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (window !== undefined) {
      let loginUser = {};
      try {
        loginUser = JSON.parse(localStorage.getItem("user"));
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }

      if (Boolean(loginUser)) {
        const { edu_company } = loginUser;
        setEduCompany(edu_company);
      } else {
        navigate("/login");
      }
    }
  }, []);

  return (
    <>
      <div
        className="modal fade custom-modal addcollege-modal"
        id="addjobScheduledule"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Add JobSchedule
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close5"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img
                      src={buildingImg}
                      width="336"
                      height="336"
                      alt="edit-jobschedule"
                    />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            className="form-select"
                            name="jobschedule_companyname"
                            value={eduCompany}
                            onChange={(e) => setEduCompany(e.target.value)}
                            // disabled={isAdminManager}
                          >
                            <option value="">Select Company</option>
                            {Array.from(
                              new Map(
                                (eduCompanyList || []).map((item) => [
                                  item.company.id,
                                  item.company,
                                ])
                              ).values()
                            ).map((company) => (
                              <option
                                className="text-black"
                                key={company.id}
                                value={company.id}
                              >
                                {company.name}
                              </option>
                            ))}
                          </select>
                          <span className="fa fa-building icon" />
                        </div>
                        {activateJobScheduleAdd &&
                          (campusList || [])?.length > 0 && (
                            <>
                              <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                                <select
                                  name="jobschedule"
                                  onChange={ChangeHandler}
                                  className="form-select"
                                  value={campusId}
                                >
                                  <option value="">Select College</option>
                                  {(campusList || []).map((arr) => {
                                    return (
                                      <option key={arr?.id} value={arr?.id}>
                                        {arr?.campus_name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <span className="fa fa-building icon" />
                              </div>

                              <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                                <select
                                  name="jobschedule_college"
                                  onChange={CollegeChangeHandler}
                                  className="form-select"
                                  value={collegeId}
                                  disabled={!campusId}
                                >
                                  <option value="">
                                    {campusId
                                      ? "Select Block"
                                      : "Please select a college first"}
                                  </option>
                                  {(blockList || []).map((block) => {
                                    return (
                                      <option key={block?.id} value={block?.id}>
                                        {block?.block_name || block?.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <span className="fa fa-building icon" />
                              </div>
                              <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                                <select
                                  name="campus"
                                  onChange={(e) =>
                                    setCleaningType(e.target.value)
                                  }
                                  className="form-select"
                                  value={cleaningType}
                                >
                                  <option value="">
                                    {cleaningType === ""
                                      ? "Select Cleaning Type"
                                      : "Clear Select"}
                                  </option>
                                  <option value="REGULAR_CLEANING">
                                    Regular Cleaning
                                  </option>
                                  <option value="TERM_CLEANING">
                                    Term Cleaning
                                  </option>
                                </select>
                              </div>
                              <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                                <input
                                  type="date"
                                  className="form-control"
                                  placeholder="Start Date"
                                  min={new Date().toISOString().split("T")[0]}
                                  value={assignDate}
                                  onChange={(e) => {
                                    setAssignDate(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          )}

                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
